'use client';

import {
  useState
} from 'react';

import
  Link
from 'next/link';

import
  SectionLayout
from '@/app/ui/section-layout';

import
  FaqItem
from '@/app/ui/faq/faq-item';

import {
  faqs
} from '@/app/data/faqs';

// Curated, not random - a homepage teaser should show the same 3 every
// time (consistent for SEO/JSON-LD, and these three are deliberately picked
// for breadth: what we offer, how to start, how to pay). Only used when the
// caller passes `preview` - the full /faqs page renders every question.
const PREVIEW_FAQ_INDICES = [ 0, 14, 12 ];

interface FaqSectionProps {
  // Homepage teaser mode: shows only PREVIEW_FAQ_INDICES + a "Learn more"
  // link to /faqs. Omit entirely for the full list (used by /faqs itself).
  preview?: boolean
}

export default function FaqSection({
  preview = false
}: FaqSectionProps) {

  const [ openIndex, setOpenIndex ] = useState<number | null>(null);

  const toggle = (i: number) => setOpenIndex(openIndex === i ? null : i);

  const visibleFaqs = preview
    ? PREVIEW_FAQ_INDICES.map((i) => faqs[i]).filter((faq) => faq !== undefined)
    : faqs;

  return (
    <SectionLayout className="bg-[#f9f9f9] dark:bg-gray-950" maxWidth="4xl" label="FAQs" heading="Our frequently asked questions.">
      <div className="space-y-3">
        {visibleFaqs.map((faq, i) => (
          <FaqItem
            key={i}
            question={faq.question}
            answer={faq.answer}
            isOpen={openIndex === i}
            onToggle={() => toggle(i)}
          />
        ))}
      </div>
      {preview && (
        <div className="text-center mt-8">
          <Link
            href="/faqs"
            className="inline-flex items-center gap-2 text-sm font-semibold transition-all duration-200 hover:gap-3"
            style={{
              color: 'rgba(1,158,250,1)'
            }}
          >
            Learn more
            <span className="sr-only">
              {' '}
              - view all frequently asked questions
            </span>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-3.5 h-3.5 fill-current">
              <path d="M438.6 278.6l-160 160C272.4 444.9 264.2 448 256 448s-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L338.8 288H32C14.33 288 .0016 273.7 .0016 256S14.33 224 32 224h306.8l-105.4-105.4c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160C451.1 245.9 451.1 266.1 438.6 278.6z" />
            </svg>
          </Link>
        </div>
      )}
    </SectionLayout>
  );
}
